import apiPrivate from './apiPrivate.service.js';

const API_URL = '/users';

class UserService {
    async getProfile() {

        try {
            const response = await apiPrivate.get(`${API_URL}/me`);
            return response.data;
        } catch (error) {
            console.error("Error fetching user profile:", error);
            throw error;
        }

    }

    async updateProfile(data) {
        try {
            const response = await apiPrivate.put(`${API_URL}/me/update`, data);
            return response.data;
        } catch (error) {
            console.error("Error updating user profile:", error);
            throw error;
        }
    }
}

export default new UserService();